<template>
    <v-navigation-drawer app clipped width="150px" class="pt-6 hidden-md-and-down lateral-nav" style="display: flex" id="nav">
      <v-list
        dense
        nav
        class="nav-lateral"
      >
        <v-list-item-group v-model="model" class="item-group">
          <v-list-item
            v-for="item in items"
            :key="item.title"
            link

            @click.stop="goTo(item.path)"
            class="text-center selected"

          >
            <v-list-item-content>
              <v-img :src="item.icon" max-width="35" class="img-icon" :class="{'btn-active': item.path === actualPath}"></v-img>
              <v-list-item-title v-if="item.class===undefined" :color="item.color" class="text">{{ item.title }}</v-list-item-title>
              <p v-else :class="item.class" >{{item.title}}</p>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="pb-10 text-center">
          <v-btn class="ma-2 close-drawer" color="#91919c" text @click="drawer(); left = false" v-model="left" v-if="left">
            <v-icon dark large>
              mdi-arrow-left
            </v-icon>
          </v-btn>
          <v-btn class="ma-2 close-drawer" color="#91919c" text @click="drawer(); left = true" v-model="left" v-if="!left">
            <v-icon dark large>
              mdi-arrow-right
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
</template>

<script>
  import fileUserLine from '@/assets/imgs/file-user-line.svg';
  import globalLine from '@/assets/imgs/global-line.svg';
  import groupLine from '@/assets/imgs/group-line.svg';
  import homeLine from '@/assets/imgs/home-line.png';
  import organism from '@/assets/imgs/university.png';
  import statistics from '@/assets/imgs/estadisticas.svg';
  export default {
    name: 'CoreDrawer',
    data () {
      return {
        right: null,
        model: 0,
        left: true,
        fileUserLine,
        globalLine,
        groupLine,
        homeLine,
        organism,
        statistics,
        isSelected: false,
        value: 1
      }
    },
    mounted(){
      //this.actualPath = window.location.pathname
    },
    computed:{
      items:{
        get(){
          var options = [
            
            { title: this.$t('projects'), icon: this.homeLine, path: '/' },
            //{ title: 'Registro de actividad', icon: 'mdi-history', path: '' },
          ]
          options.push({
            title: this.$t('my registry'),  icon: this.fileUserLine, path:'/history'
          })
          if(this.$store.getters.getRole !== "downloader"){
            options.push({
              title: this.$t('activity'),  icon: this.globalLine, path:'/history/projects'
            })
          }
          if(this.$store.getters.getRole === "admin"){
            var opt= { title: this.$t('users'), icon: this.groupLine , path: '/users' }
            options.splice(1,0,opt)
          }
          if(this.$store.getters.getRole === "admin"){
            options.push({
              title: this.$t('organisms'),  icon: this.organism, path:'/organism'
            })
          }
          if(this.$store.getters.getRole === "legal_auditor"){
            options.push({
              title: this.$t('statistics'),  icon: this.statistics, path:'/statistics'
            })
          }
          return options
        }
      },

      actualPath() {
        return this.$route.path
      }
    },
    methods:{
      goTo(path){
        let date = new Date()
        this.$store.commit('setStartDate', date.toISOString().split("T")[0])
        this.$store.commit("setSelectedStatistic", this.$t('projects'));
        this.$store.commit('setRange', 'day')
        this.$store.commit('setSearch', '')
        this.$store.commit('setSearchInterval', 0)
        this.$store.commit('setPage', 1)
        this.$store.commit('setActualPage', 1)
        this.$store.commit('setStatus', '')
        this.$store.commit('setFooterKey', this.$store.getters.getFooterKey + 1)
        this.$store.commit('setMakeRequest', true)
        //this.$store.commit('setUpdateProjectViewer',this.$store.getters.getUpdateProjectViewer + 1)
         if (this.$router.currentRoute.path !== '/'){
          this.$store.commit('setDisplayDrawer', false)
        }
        if(path !== this.actualPath){
          this.$router.push(path)
        }
        
      },
      drawer(){
        let nav = document.getElementById("nav")
        let text = document.getElementsByClassName("text")
        if (this.left === true){
          nav.classList.add('lateral-nav-size')
          this.$store.commit('setWindowWidth', true)
          text.forEach(element => {
            element.classList.add('not-visible')
          });
        }else{
          nav.classList.remove('lateral-nav-size')
          this.$store.commit('setWindowWidth', false)
          text.forEach(element => {
            element.classList.remove('not-visible')
          })
        }
      },
      }
    }
</script>

<style>
  .nav-lateral{
    padding: 0!important;
  }
  .v-navigation-drawer__border{
    background-color: #f5f5f5!important;
  }
  .item-group{
    background-color: #f5f5f5!important;
  }
  .not-visible{
    visibility: hidden;
  }
  .lateral-nav-size{
    width: 90px!important;
  }
  .lateral-nav{
    display: flex!important;
    flex-direction: column!important;
    justify-content: space-between!important;
    background-color: #f5f5f5!important;
  }
  .nav-subtitle{
    height: 10px
  }
  .close-drawer{
    font-size: 20px!important;
  }
  .close-drawer::before{
    background-color: transparent!important;
  }
  .close-drawer::after{
    background-color: transparent!important;
  }
  .img-icon{
    margin: 0 auto;
  }
  .img-icon:hover{
    filter: brightness(0.5) sepia(5) hue-rotate(170deg) saturate(10);
  }
  .btn-active{
    filter: brightness(0.5) sepia(5) hue-rotate(170deg) saturate(10);
    background-color: transparent!important;
  }
  .selected::before{
    background-color: transparent!important;
  }

</style>